// extracted by mini-css-extract-plugin
export default {"content":"BreadCrumbs_content__fE3mV","crumbLink":"BreadCrumbs_crumbLink__kBGBw","separator":"BreadCrumbs_separator__B0jXo"};